
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import LanguageData from "../json/LanguageData.json";
import moment from 'moment';

Vue.use(Vuex)

const REVIEW_USER_DATA_KEY = "reviewUserData";

const getDefaultState = () => ({
    sections: [
        "Features",
        "Platforms",
        "Category",
        "Add Products",
        "Product Review",
        "Pincodes",
        "Search Terms",
        "Frequency"
    ],
    selectedSection: "",
    loader: false,
    totalFeatures: null,
    selectedFeatures: [],
    totalPlatforms: [],
    selectedPlatforms: [],
    updatedDateTimeStamp: "",
    storeUpdatedStatus: '',
    selectedRegion: {
        id: '',
        name: ''
    },
    selectedLanguage: { key: "en", value: "English", flag: "🇬🇧" },
    languages: LanguageData,
    translatedLang: LanguageData,
    selectedPlugNPlayPlatform: "amazon",
    disparityProductDetails:{
        selectedDateRange:{
            startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
        },
        selectedCategory: [],
        selectedSubCategory: [],
        selectedBrand: [],
        selectedPlatform: [],
        selectedPriceRange: [],
        selectedProduct: [],
        selectedPincode: [],
        selectedBatch: [],
        sosCompare:{}
    }
});

const hasLocalStorage = () =>
    typeof window !== "undefined" && typeof window.localStorage !== "undefined";

const isUserLoggedIn = () =>
    hasLocalStorage() && !!window.localStorage.getItem(REVIEW_USER_DATA_KEY);

const persistedStatePlugin = createPersistedState({
    paths: ["DemoStore"],
    filter: () => isUserLoggedIn(),
    getState: (key, storage) => {
        if (!isUserLoggedIn()) {
            return;
        }
        const value = storage.getItem(key);
        try {
            return value ? JSON.parse(value) : undefined;
        } catch {
            return undefined;
        }
    },
});

export const DemoStore = {
    namespaced: true,
    state: getDefaultState,
    mutations: {
        SET_SOS_COMP_Filter(state,data){
            state.sosCompare = data
        },

        SET_TIMESTAMP(state, time) {
            state.updatedDateTimeStamp = "";
            state.updatedDateTimeStamp = time;
        },
        SET_SECTIONS(state, sections) {
            state.sections = sections;
        },
        SET_SELECTED_SECTION(state, section) {
            state.selectedSection = section;
        },
        SET_LOADER(state, loader) {
            state.loader = loader;
        },
        SET_TOTAL_FEATURES(state, features) {
            state.totalFeatures = features;
        },
        SET_SELECTED_FEATURES(state, selectedFeatures) {
            state.selectedFeatures = selectedFeatures;
        },
        SET_TOTAL_PLATFORMS(state, platforms) {
            state.totalPlatforms = platforms;
        },
        SET_SELECTED_PLATFORMS(state, selectedPlatforms) {
            state.selectedPlatforms = selectedPlatforms;
        },
        SET_UPDATED_STATUS(state, status) {
            state.storeUpdatedStatus = '';
            state.storeUpdatedStatus = status;
        },
        SET_SELECTED_REGION(state, region) {
            state.selectedRegion = region;
        },
        SET_SELECTED_LANGUAGE(state, lang) {
            state.selectedLanguage = lang;
            state.translatedLang = state.languages;
        },
        SET_SELECTED_PlugNPlay_Platform(state, platform) {
            state.selectedPlugNPlayPlatform = platform;
        },
        SET_SELECTED_Disparity_Filters(state, filters) {
           state.disparityProductDetails = {
            ...state.disparityProductDetails,
            ...filters,
        };
        },
        INIT_TRANSLATION(state) {
            state.translatedLang = state.languages || "Translation not found";
        },
        RESET_STATE(state) {
            Object.assign(state, getDefaultState());
        }
    },
    actions: {
        setSections({ commit }, sections) {
            commit('SET_SECTIONS', sections)
        },
        setSelectedSection({ commit }, section) {
            commit('SET_SELECTED_SECTION', section)
        },
        setDemoLoader({ commit }, loader) {
            commit('SET_LOADER', loader)
        },
        setTotalFeatures({ commit }, features) {
            commit('SET_TOTAL_FEATURES', features)
        },
        setSelectedFeatures({ commit }, selectedFeatures) {
            commit('SET_SELECTED_FEATURES', selectedFeatures)
        },
        setTotalPlatforms({ commit }, platforms) {
            commit('SET_TOTAL_PLATFORMS', platforms)
        },
        setSelectedPlatforms({ commit }, selectedPlatforms) {
            commit('SET_SELECTED_PLATFORMS', selectedPlatforms)
        },
        setTimeStamp({ commit }, time) {
            commit('SET_TIMESTAMP', time)
        },
        setUpdatedStatus({ commit }, status) {
            commit('SET_UPDATED_STATUS', status)
        },
        setSelectedRegion({ commit }, region) {
            commit('SET_SELECTED_REGION', region)
        },
        setSelectedLanguage({ commit }, langKey) {
            commit('SET_SELECTED_LANGUAGE', langKey)
        },
        setSelectedPlugNPlayPlatform({ commit }, platform) {
            commit('SET_SELECTED_PlugNPlay_Platform', platform)
        },
        setSelectedDisparityFilters({ commit }, filters) {
            commit('SET_SELECTED_Disparity_Filters', filters)
        },
        initializeTranslation({ commit }) {
            commit("INIT_TRANSLATION");
        },
        setSOSCompFilter({commit},filters){
            commit('SET_SOS_COMP_Filter',filters)
        },
        resetState({ commit }) {
            commit('RESET_STATE')
        }
    },
}

const store = new Vuex.Store({
    modules: {
        DemoStore
    },
    plugins: [persistedStatePlugin],
});

export default store;
